import Date from '../../../../Core/Fields/Floating/Date';
import { useState } from 'react';
import Input from '../../../../Core/Fields/Floating/Input';
import Textarea from '../../../../Core/Fields/Floating/Textarea';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';
import CollapsibleSection from '../../../../Core/CollapsibleSection/CollapsibleSection';
import GetIcon from '../../../../utils/Icon';
import VersionHistory from '../../../../utils/VersionHistory';
import ReadOnlyField from '../../../../utils/ReadOnlyField';
const Tab1 = ({ vendor,realponumber, required_date, selectedAddress, podate, ponumber, activityboll, pTerms, termandcondition, taxandchanges, cost_center, project, currency, price,setasn_inclusion,asn_inclusion }) => {
  const [showActivity, setShowActivity] = useState(true);
  
  return (
    <div
      // className="row sidebarbox m-0 "
      className="row sidebarbox m-0 d-flex flex-column"
      style={{ flexWrap: 'nowrap', padding: "8px", borderRadius: "5px", height: "72vh", overflowY: "scroll" }}
    >
      <div className="col-12">
        <div className="row">
          <div className="col-md-6 mt-1 mb-2" >
            <Input id="orderNo" label="No." value={realponumber} readOnly={true} style={{ height: '30px' }} />
          </div>
          <div className="col-md-6 mt-1">
            <Input id="orderdatepo" type="date" style={{ height: '30px' }} readOnly label="Order Date" value={podate.podate} onChange={(e) => podate.setpodate(e.target.value)} />
          </div>
        </div>
      </div>
     {console.log("vendorvendorvendorvendor",vendor)}
      <div className="col-12 ">
        <div className={vendor.Error ? `mb-3 errorborder` : `mb-3`}>
          {ponumber ? <Input
            id="orderNo"
            label="Select Supplier"
            readOnly
            value={vendor.select_vendor}
            style={{ height: '30px' }}
          /> : <SelectSearch
            list={vendor.vendor_list}
            label="Select Supplier"
            getOptionLabel={(item) => item.name}
            getOptionValue={(item) => item.name}
            value={vendor.select_vendor}
            onChange={(val) => vendor.setselect_vendor(val)}
          />}

        </div>
      </div>
      <div className="col-12">
        <div className="mb-3">
          <Textarea
            id="ponumber"
            label="Supplier Address"
            value={
              selectedAddress.currentAddress?.name
                ? `${selectedAddress.currentAddress?.address_line1}, ${selectedAddress.currentAddress?.address_line2},\n ${selectedAddress.currentAddress?.city}, ${selectedAddress.currentAddress?.state} ${selectedAddress.currentAddress?.country} - ${selectedAddress.currentAddress?.pincode}`
                : ''
            }
            readOnly={true}

            style={{
              whiteSpace: 'pre-wrap',
              border: selectedAddress.Error ? '1px solid red' : ''
            }}
          />
        </div>

      </div>
      <div className="col-12 ">
        <div className="mb-3 " >
          {ponumber ? <Input
            id="orderNo"
            label="Required By"
            readOnly
            value={required_date.required_date}
            style={{ height: '30px' }}
          /> : <Date
            id="requireddata"
            label="Required By"
            value={required_date.required_date}
            onChange={(e) => required_date.setrequired_date(e.target.value)}
            error={required_date.Error}
            min={true}
          />}
        </div>
      </div>
<div style={{ display: 'flex', alignItems: 'center' }}>
  <input
    type="checkbox"
    id="asnInclusion"
    checked={asn_inclusion}
    onChange={(e) => setasn_inclusion(e.target.checked)}
    style={{ accentColor: asn_inclusion ? '#270B79' : '#ccc' }} 
  />
  <label htmlFor="asnInclusion" style={{ marginLeft: '5px', fontSize: '0.85rem' }}>
    ASN Inclusion
  </label>
</div>



      <CollapsibleSection title="Accounting Dimensions">
        <div className="col-lg-12 mt-3 mb-3" >
         <ReadOnlyField read={ponumber} attributes={{label:'Cost Center',value:cost_center.value}} >
          
          <div className={cost_center.Error ? `mb-3 errorborder` : `mb-3`}>
            <SelectSearch
              list={cost_center.list}
              label="Cost Center"
              getOptionLabel={(item) => item.name}
              getOptionValue={(item) => item.name}
              value={cost_center.value}
              onChange={(val) => cost_center.setvalue(val)}
            />
          </div>
          </ReadOnlyField>
        </div>
        <div className="col-lg-12 mt-3 mb-3" >
         <ReadOnlyField read={ponumber} attributes={{label:'Project',value:project.value}} >
          <div className={project.Error ? `mb-3 errorborder` : `mb-3`}>
            <SelectSearch
              list={project.list}
              label="Project"
              getOptionLabel={(item) => item.name}
              getOptionValue={(item) => item.name}
              value={project.value}
              onChange={(val) => project.setvalue(val)}
            />
          </div>
          </ReadOnlyField>
        </div>
      </CollapsibleSection>

      <CollapsibleSection title="Currency and Price List">
        <div className="col-lg-12 mt-3 mb-3" >
          <ReadOnlyField read={ponumber} attributes={{label:'Currency',value:currency.value}} >
          <div className={currency.Error ? `mb-3 errorborder` : `mb-3`}>
            <SelectSearch
              list={currency.list}
              label="Currency"
              getOptionLabel={(item) => item.name}
              getOptionValue={(item) => item.name}
              value={currency.value}
              onChange={(val) => currency.setvalue(val)}
            />
          </div>
          </ReadOnlyField>
        </div>

        <div className="col-lg-12 mt-3 mb-3" >
          <ReadOnlyField read={ponumber} attributes={{label:'Price List',value:price.value}} >
          <div className={price.Error ? `mb-3 errorborder` : `mb-3`}>
            <SelectSearch
              list={price.list}
              label="Price List"
              getOptionLabel={(item) => item.name}
              getOptionValue={(item) => item.name}
              value={price.value}
              onChange={(val) => price.setvalue(val)}
            />
          </div>
          </ReadOnlyField>
        </div>
      </CollapsibleSection>
      <CollapsibleSection title="Taxes and Charges">
        <div className="col-lg-12 mt-3 mb-3" >
          <ReadOnlyField read={ponumber} attributes={{label:'Taxes and Charges',value:taxandchanges.value}} >
          <div className={taxandchanges.Error ? `mb-3 errorborder` : `mb-3`}>
            <SelectSearch
              list={taxandchanges.list}
              label="Taxes and Charges"
              getOptionLabel={(item) => item.name}
              getOptionValue={(item) => item.name}
              value={taxandchanges.value}
              onChange={(val) => taxandchanges.setvalue(val)}
            />
          </div>
          </ReadOnlyField>
        </div>
      </CollapsibleSection>


      <CollapsibleSection title="Payment Terms">
        <div className="col-lg-12 mt-3 mb-3" >
          <ReadOnlyField read={ponumber} attributes={{label:'Payment Terms Template',value:pTerms.paymentterm}} >
          <div className={pTerms.Error ? `mb-3 errorborder` : `mb-3`}>
            <SelectSearch
              list={pTerms.list}
              label="Payment Terms Template"
              getOptionLabel={(item) => item.name}
              getOptionValue={(item) => item.name}
              value={pTerms.paymentterm}
              onChange={(val) => pTerms.setpaymentterm(val)}
            />
          </div>
          </ReadOnlyField>
        </div>

      </CollapsibleSection>

      <CollapsibleSection title="Terms & Conditions">

        <div className="col-lg-12 mt-1 mb-3" >
          <ReadOnlyField read={ponumber} attributes={{label:'Terms and Conditions',value:termandcondition.termsandcondition}} >
          <div className={termandcondition.Error ? `mb-3 errorborder` : `mb-3`}>
            <SelectSearch
              list={termandcondition.list}
              label="Terms and Conditions"
              getOptionLabel={(item) => item.name}
              getOptionValue={(item) => item.name}
              value={termandcondition.termsandcondition}
              onChange={(val) => termandcondition.settermsandcondition(val)}
            />
          </div>
          </ReadOnlyField>
        </div>

      </CollapsibleSection>
      <div >

        <div className="col-12">
          <div className="py-2 d-flex justify-content-between align-items-center" onClick={() => setShowActivity(!showActivity)}>
            <p className="firstcolor m-0">
              Activity
            </p>
            <GetIcon
              iconName={showActivity ? "MdKeyboardArrowUp" : "MdKeyboardArrowDown"}
              size={22}
            />
          </div>

          {showActivity && (
            <VersionHistory doctype="Purchase Order" docname={ponumber} activityboll={activityboll} />

          )}
        </div>


      </div>
    </div>
  )
}

export default Tab1